import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";
import MainLayout from "./Layout/MainLayout";
import Invitation from "./View/Invitation/Invitation";
import Contactlist from "./View/ContactList/Contactlist";
import Owncontactlist from "./View/OwnContactlist/Owncontactlist";
// import Owncontactlist2 from "./View/OwnContactlist/Owncontactlist2";
import Memberinvitation from "./View/Memberinvitation/Memberinvitation";
import Memberownprofile from "./View/MemberownProfile/Memberownprofile";
import Memberuserprofile from "./View/MemberUserprofile/Memberuserprofile";
import NonMemberuserprofile from "./View/NonMemberuserprofile/NonMemberuserprofile";
import Home from "./View/Homepage/Home";
import LoginNew from "./Authentication/LoginNew";
import ForgotPassword from "./Authentication/ForgotPassword";
import ResetPassword from "./Authentication/ResetPassword";
import HomeLayout from "./Layout/HomeLayout";
import LoginLayout from "./Layout/LoginLayout";
import PrivateRouter from "./privateRouter/PrivateRouter";
import { Toaster } from "react-hot-toast";
import Loader from "./Component/Loader";
import Reward from "../src/View/Reward/Index";
import MemberOtherProfile from "./View/MemberownProfile/MemberOtherProfile";
import RewardPointsSummary from "./View/Reward/RewardPointsSummary";
import NonMemberuserOtherprofile from "./View/NonMemberuserprofile/NonMemberuserOtherprofile";
import MemberOtherSavedProfile from "./View/MemberownProfile/MemberOtherSavedProfile";
import NonMemberuserSavedProfile from "./View/NonMemberuserprofile/NonMemberuserSavedProfile";
import OffersCategories from "../src/View/Reward/OffersCategories";
import OffersCategoriesDetails from "./View/Reward/OffersCategoriesDetails";
import LetsgetinTouch from "./View/OthersPages/LetsgetinTouch";
import OurPartners from "./View/Reward/OurPartners";
import RedeemyourPoints from "./View/Reward/RedeemyourPoints";
import MyWalletPage from "./View/Reward/MyWalletPage";
import RewardsAbout from "./View/Reward/RewardsAbout";
import HowWorkRewards from "./View/Reward/HowWorkRewards";
import HowRedeem from "./View/Reward/HowRedeem";
import VenderDashboard from "./View/VenderDashboard/Index";
import OfferStatsInnerPage from "./View/VenderDashboard/OfferStatsInnerPage";
import RedeemedStatsInnerPage from "./View/VenderDashboard/RedeemedStatsInnerPage";
import AboutNeooSearch from "./View/OthersPages/AboutNeooSearch";
import TermsofServices from "./View/OthersPages/TermsofServices";
import PrivacyPolicy from "./View/OthersPages/PrivacyPolicy";
import UserVoucherCode from "./View/VenderDashboard/UserVoucherCode";
import { useEffect, useState } from "react";
import HttpClient from "./utils/HttpClient";
import LandingPage from "./View/Homepage/LandingPage";
import CategoryWiseAllOffersDetals from "./View/Reward/CategoryWiseAllOffersDetals";
import OfferVoucherIssuedStats from "./View/VenderDashboard/OfferVoucherIssuedStats";
import OfferViewStats from "./View/VenderDashboard/OfferViewStats";
import ProductsAndServices from "./View/OthersPages/ProductsAndServices";
import RewardHomePage from "./View/RewardsHomePage/RewardHomePage";
import ReferAndEarnHome from "./View/ReferAndEarnPage/ReferAndEarnHome";
import Explore from "./View/Explore/Explore";
import ChatIndex from "./View/Chatpage/ChatIndex";
import HowEarningRewards from "./View/Reward/HowEarningRewards";
import { reactLocalStorage } from "reactjs-localstorage";
import PeopleAcceleratorProgram from "./View/PeopleAccelerator/Index";
import SingleChatArea from "./View/Chatpage/SingleChatArea";
import { useDispatch, useSelector } from "react-redux";
import { getOwnProfile } from "./Redux/Slice/PostSlice";
// import {
//   onDisconnect,
//   ref,
//   serverTimestamp,
//   set,
//   update,
// } from "firebase/database";
// import { db } from "./Firebase/FirebaseConfig";
import ReferEarnDashboard from "./View/ReferEarnDashboard/Index";
import GenerateLinkPage from "./View/ReferEarnDashboard/GenerateLinkPage";
import TodayEarningsPage from "./View/ReferEarnDashboard/TodayEarningsPage";
import MonthlyEarningsPage from "./View/ReferEarnDashboard/MonthlyEarningsPage";
import JoinedMembersPage from "./View/ReferEarnDashboard/JoinedMembersPage";
import JoinedNonMembersPage from "./View/ReferEarnDashboard/JoinedNonMembersPage";
import WithdrawHome from "./View/WIthdraw/WithdrawHome";
import TotalEarned from "./View/WIthdraw/TotalEarned";
import AvailableBalance from "./View/WIthdraw/AvailableBalance";
import TransferNow from "./View/WIthdraw/TransferNow";
import SuccessWithdraw from "./View/WIthdraw/SuccessWithdraw";
import BankAccountUpdate from "./View/WIthdraw/BankAccountUpdate";
import Logedsearch from "./View/LogedSearch/Logedsearch";
import HomeSearchLayout from "./Layout/HomeSearchLayout";
import Searchhome from "./View/SearchHome/Searchhome";
import SearchLogin from "./View/SearchHome/SearchLogin";
// import Searchloginform from "./View/SearchHome/Searchloginform";
// import Listbusinessform from "./View/SearchHome/Listbusinessform";
import BusinessInfoform from "./View/SearchHome/BusinessInfoform";
import Ownblmprofile from "./View/SearchHome/Ownblmprofile";
import Otherblmprofile from "./View/SearchHome/Otherblmprofile";
import Ownpostpage from "./View/SearchHome/Ownpostpage";
import Ownsearchresult from "./View/SearchHome/Ownsearchresult";
import Businessdirectory from "./View/SearchHome/Businessdirectory";
import Membermasterdashbord from "./View/SearchHome/Membermasterdashbord";
import Blmemberlist from "./View/SearchHome/Blmemberlist";
import Paymentpage from "./View/SearchHome/Paymentpage";
import UserProfile from "./View/SearchHome/UserProfile";
import ChooseMemberPlan from "./View/SearchHome/ChooseMemberPlan";
import ProfilePaymentpage from "./View/SearchHome/ProfilePaymentpage";
import MemberStatus from "./View/SearchHome/MemberStatus";
import PlanUpgrade from "./View/SearchHome/PlanUpgrade";
import OwnEnquiries from "./View/SearchHome/OwnEnquiries";
import Analytics from "./View/SearchHome/Analytics";
import AnalyticsReport from "./View/SearchHome/AnalyticsReport";
import AnalyticsProfile from "./View/SearchHome/AnalyticsProfile";
import CardMemberRegistration from "./View/CardMember/CardMemberRegistration";
import CardMemberRegistrationDetails from "./View/CardMember/CardMemberRegistrationDetails";
import CardMemberRegistrationProfileName from "./View/CardMember/CardMemberRegistrationProfileName";
import BusinessDigitalCard from "./View/BusinessDigitalCard/BusinessDigitalCard";
import { HelmetProvider } from 'react-helmet-async';
import UserAgreement from "./View/OthersPages/UserAgreement";
import ScrollToTop from "./utils/ScrollToTop";
// import SearchList from "./View/SearchHome/SearchList";
// import ListBusinessSignUp from "./View/SearchHome/ListBusinessSignUp";
import ContactDirectory from "./View/OwnContactlist/ContactDirectory";
// import ListBusinessContactForm from "./View/SearchHome/ListBusinessContactForm";
// import ListBusinessProfile from "./View/SearchHome/ListBusinessProfile";
// import ListBusinessMyPage from "./View/SearchHome/ListBusinessMyPage";
// import ListBusinessPaymentPage from "./View/SearchHome/ListBusinessPaymentPage";
import NotFound from "./View/Pages/NotFound";
// import BusinessListingWizard from "./View/BusinessListing/BusinessListingWizard";
// import ContactInformation from "./View/BusinessListing/components/ContactInformation";
import BusinessListingWizardAccount from "./View/BusinessListing/BusinessListingWizardAccount";
import BusinessListingWizardPersonal from "./View/BusinessListing/BusinessListingWizardPersonal";
import BusinessListingPublicWizard from "./View/BusinessListing/BusinessListingPublicWizard";
import ResetPasswordNew from "./Authentication/ResetPasswordNew";
import SettingsPage from "./View/Settings/SettingsPage";
import SearchRewardCards from "./View/Reward/SearchRewardCards";
import CombinedBusinessPage from "./View/BusinessPage/CombinedBusinessPage";
import MyProfile from "./View/MemberownProfile/MyProfile";
import FaqListPage from "./View/Faq/FaqListPage";
import TechnicalSpecificationPage from "./View/TechnicalSpecification/TechnicalSpecificationPage";
import PostDetailspage from "./View/SearchHome/PostDetailspage";

function App() {
  const [contact, setsavedContacts] = useState([]);
  const dispatch = useDispatch();

  const { UserProfileID } = useSelector((state) => state?.app);
  const { chatListData, singleChatData, RecieverID } = useSelector(
    (state) => state?.chat
  );
  let user = reactLocalStorage.get("userDataNeoCard");
  const savedContactList = async () => {
    const res = await HttpClient.requestData("member-contacts", "GET", {});
    if (res && res?.status) {
      setsavedContacts(res?.data);
    }
  };
  useEffect(() => {
    savedContactList();
    dispatch(getOwnProfile());
  }, []);
  // firebase

  // firebase account creation

  /////////////////////////////////////////
  // www. problem solved this code  is for routing in react application please comment this
  // useEffect while working on localhost and make it uncomment for the proper effect  of the website
  /////////////////////////////////////////

  // useEffect(() => {
  //   const handleUrlChange = () => {
  //     const currentUrl = window.location.href;
  //     const protocolIndex = currentUrl.indexOf('://');
  //     if (protocolIndex !== -1) {
  //       const afterProtocol = currentUrl.substring(protocolIndex + 3);
  //       if (!afterProtocol.startsWith('www.')) {
  //         const newUrl = `https://www.${afterProtocol}`;
  //         window.location.href = newUrl;
  //       }
  //     }
  //   };

  //   // Listen for changes in the URL
  //   window.addEventListener('load', handleUrlChange);

  //   // Clean up the event listener
  //   return () => {
  //     window.removeEventListener('load', handleUrlChange);
  //   };
  // }, []);

  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster />
          <Routes>
            <Route path="/" element={<HomeSearchLayout />}>
              {/* <Route path="/business-card" element={<BusinessDigitalCard />} /> */}
              <Route path="/" element={<Searchhome />} />


              {/* <Route path="/priceandplan" element={<SearchLogin />} /> */}
              <Route path="/business-directory-listing-pricing" element={<SearchLogin />} />

              {/* <Route path="/signup" element={<Searchloginform />} /> */}
              {/* <Route path="/signup" element={<ListBusinessSignUp />} /> */}
              {/* <Route path="/signup" element={<BusinessListingPublicWizard />} /> */}
              <Route path="/businesslisting" element={<BusinessListingPublicWizard />} />

              {/* <Route path="/listbusiness" element={<Listbusinessform />} /> */}
              {/* <Route path="/listbusiness" element={<ListBusinessContactForm />} />
              <Route path="/create-profile-name" element={<ListBusinessProfile />} />
              <Route path="/create-business-page" element={<ListBusinessMyPage />} />
              <Route path="/list-business-payment" element={<ListBusinessPaymentPage />} /> */}

              {/* <Route path="/businesinfoform" element={<BusinessInfoform />} /> */}
              <Route path="/ownblmprofile" element={<Ownblmprofile />} />
              <Route path="/otherblmprofile" element={<Otherblmprofile />} />
              <Route path="/ownpostpage" element={<Ownpostpage />} />
              <Route path="/ownpostpage/:id" element={<PostDetailspage />} />
              <Route path="/ownsearchresult" element={<Ownsearchresult />} />
              <Route path="/upgradeplan" element={<PlanUpgrade />} />
              <Route path="/myenquiries" element={<OwnEnquiries />} />
              {/* Static Pages */}
              <Route path="/about-neoo-search" element={<AboutNeooSearch />} />
              <Route path="/products-and-services" element={<ProductsAndServices />} />
              {/* <Route path="/reward-home-page" element={<RewardHomePage />} /> */}
              <Route path="/user-agreement" element={<UserAgreement />} />
              <Route path="/terms-of-services" element={<TermsofServices />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />

              {/* <Route path="/businessdirectory" element={<Businessdirectory />} /> */}
              <Route path="/about-business-directory" element={<Businessdirectory />} />


              {/* <Route path="/masterdashbord" element={<Membermasterdashbord />} /> */}


              {/* ROUTE ADDED FOR ANALYTICS PAGE */}




              {/* ROUTE ADDED FOR MEMBER STATUS PAGE */}


              <Route path="/paymentpage" element={<Paymentpage />} />
              <Route path="/search" element={<Blmemberlist />} />
              {/* <Route path="/choosememberplan" element={<ChooseMemberPlan />} /> */}

              {/* Card Member Registration - Page1 */}
              {/* <Route path="/create-businesscard" element={<CardMemberRegistration />} /> */}
              <Route path="/free-digital-business-card" element={<CardMemberRegistration />} />
              <Route path="/create-businesscard-details" element={<CardMemberRegistrationDetails />} />
              <Route path="/create-businesscard-profile" element={<CardMemberRegistrationProfileName />} />
              <Route path="/faq" element={<FaqListPage />} />
              <Route path="/technical-specification" element={<TechnicalSpecificationPage />} />

              {!UserProfileID && (
                <Route path="/businesspage/:name" element={<CombinedBusinessPage />} />
              )}
            </Route>

            <Route path="/" element={<HomeLayout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/user-login" element={<Home />} />

            </Route>

            <Route path="/" element={<MainLayout />}>
              {UserProfileID && (
                <Route path="/businesspage/:name" element={<CombinedBusinessPage />} />
              )}
            </Route>

            <Route path="/" element={<LoginLayout />}>
              <Route path="/activate-neoocard" element={<LoginNew />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/resetPassword" element={<ResetPassword />} />
              <Route path="/reset-password/:key" element={<ResetPasswordNew />} />

              <Route path="/lets-get-intouch" element={<LetsgetinTouch />} />
              {/* <Route path="/about-neoo-search" element={<AboutNeooSearch />} /> */}
              {/* <Route path="/terms-of-services" element={<TermsofServices />} /> */}
              {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
              {/* <Route path="/user-agreement" element={<UserAgreement />} /> */}

              {/* <Route path="/products-and-services" element={<ProductsAndServices />} /> */}
              {/* <Route path="/reward-home-page" element={<RewardHomePage />} /> */}
              <Route path="/business-reward-program" element={<RewardHomePage />} />

              <Route path="/refer-and-earn" element={<ReferAndEarnHome />} />
              <Route path="/explore" element={<Explore />} />
              {/* <Route path="/neoocard" element={<BusinessDigitalCard />} /> */}
              <Route path="/about-neoocard" element={<BusinessDigitalCard />} />
              <Route
                path="/business-accelerator-program"
                element={<PeopleAcceleratorProgram />}
              />
              <Route path="/logedsearch" element={<Logedsearch />} />
            </Route>

            <Route element={<PrivateRouter />}>
              <Route path="/" element={<MainLayout />}>
                <Route path="/businesinfoform" element={<BusinessInfoform />} />
                <Route path="/masterdashbord" element={<Membermasterdashbord />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/analytics-profile" element={<AnalyticsProfile />} />
                <Route path="/analytics-report" element={<AnalyticsReport />} />
                <Route path="/status" element={<MemberStatus />} />
                <Route path="/member/:name" element={<UserProfile />} />
                {/* <Route path="/ownpostpage/:id" element={<Ownpostpage />} /> */}
                {/* <Route path="/businesspage/:name" element={<UserProfile />} /> */}
                <Route path="/profilepaymentpage" element={<ProfilePaymentpage />} />

                <Route path="/Invitation" element={<Invitation />} />

                {/* <Route path="/profile/:name" element={<Memberownprofile />} /> */}
                <Route path="/profile/:name" element={<MyProfile />} />
                <Route
                  path="/MemberOtherProfile/:name"
                  element={<MemberOtherProfile />}
                />
                <Route
                  path="/MemberOtherSavedProfile/:name"
                  element={<MemberOtherSavedProfile />}
                />
                <Route
                  path="/Memberuserprofile"
                  element={<Memberuserprofile />}
                />
                <Route
                  path="/NonMemberuserprofile/:name"
                  element={<NonMemberuserprofile />}
                />
                <Route
                  path="/NonMemberuserOtherprofile/:name"
                  element={<NonMemberuserOtherprofile />}
                />
                <Route
                  path="/NonMemberuserSavedProfile/:name"
                  element={<NonMemberuserSavedProfile />}
                />
                <Route path="/Contactlist" element={<Contactlist />} />
                <Route path="/Owncontactlist2" element={<Owncontactlist />} />
                <Route path="/Owncontactlist" element={<ContactDirectory />} />
                <Route path="/chat" element={<ChatIndex />} />
                <Route path="/single-chat" element={<SingleChatArea />} />
                <Route path="/reward" element={<Reward />} />
                <Route
                  path="/reward-points-summary"
                  element={<RewardPointsSummary />}
                />
                <Route path="/offers-categories" element={<OffersCategories />} />
                <Route
                  path="/offers-categories-details/:name/:id"
                  element={<OffersCategoriesDetails />}
                />
                <Route
                  path="/category-wise-offers/:name/:id"
                  element={<CategoryWiseAllOffersDetals />}
                />
                <Route path="/our-partners" element={<OurPartners />} />
                <Route path="/redeemyour-points" element={<RedeemyourPoints />} />
                <Route path="/my-wallet" element={<MyWalletPage />} />
                <Route path="/rewards-about" element={<RewardsAbout />} />
                <Route path="/how-work-rewards" element={<HowWorkRewards />} />
                <Route path="/neoo-search-reward-cards" element={<SearchRewardCards />} />

                <Route
                  path="/how-earning-rewards"
                  element={<HowEarningRewards />}
                />
                <Route path="/how-redeem" element={<HowRedeem />} />

                <Route path="/vender-dashboard" element={<VenderDashboard />} />

                <Route
                  path="/refer-earn-dashboard"
                  element={<ReferEarnDashboard />}
                />
                <Route path="/generate-Link" element={<GenerateLinkPage />} />
                <Route path="/today-earnings" element={<TodayEarningsPage />} />
                <Route
                  path="/monthly-earnings"
                  element={<MonthlyEarningsPage />}
                />
                <Route path="/joined-members" element={<JoinedMembersPage />} />
                <Route
                  path="/joined-non-members"
                  element={<JoinedNonMembersPage />}
                />

                <Route path="/withdraw" element={<WithdrawHome />} />
                <Route path="/total-earned" element={<TotalEarned />} />
                <Route path="/available-balance" element={<AvailableBalance />} />
                <Route path="/transfer-now" element={<TransferNow />} />
                <Route path="/success" element={<SuccessWithdraw />} />
                <Route
                  path="/bank-account-update"
                  element={<BankAccountUpdate />}
                />

                {/* VoucherRedeemed stats page */}
                <Route
                  path="/offer-voucher-redeemed"
                  element={<OfferStatsInnerPage />}
                />
                {/* voucher issued stats */}
                <Route
                  path="/offer-voucher-issued"
                  element={<OfferVoucherIssuedStats />}
                />
                {/* Offer views */}
                <Route path="/offer-view" element={<OfferViewStats />} />
                <Route
                  path="/redeemed-stats-inner"
                  element={<RedeemedStatsInnerPage />}
                />
                <Route path="/user-voucher-code" element={<UserVoucherCode />} />

                <Route path="/list-business-account/:name" element={<BusinessListingWizardAccount />} />
                <Route path="/list-business-personal/:name" element={<BusinessListingWizardPersonal />} />
                <Route path="/settings" element={<SettingsPage />} />

              </Route>
            </Route>

            <Route
              path="/Memberinvitation/:name"
              element={<Memberinvitation />}
            />


            <Route path="/Loader" element={<Loader />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

export default App;
